import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../../stores/user-store/advanced-store";
import CriteriaForm from "./criteria-form";
import OptionForm from "./option-form";

const UserFieldsForm = withLiteObserverAndTheme(() => {
  const userAdvancedStore = getUserAdvancedStore();
  const shoulShowOptionSearch = userAdvancedStore.shouldShowOptionForm.get();
  const shoulShowCriteriaSearch =
    userAdvancedStore.shouldShowCriteriaForm.get();

  return shoulShowOptionSearch ? (
    <OptionForm />
  ) : shoulShowCriteriaSearch ? (
    <CriteriaForm />
  ) : null;
});

export default UserFieldsForm;
